import { render, staticRenderFns } from "./V2AdditionalInfo.vue?vue&type=template&id=1488f6b8&scoped=true&"
import script from "./V2AdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./V2AdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./V2AdditionalInfo.vue?vue&type=style&index=0&id=1488f6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488f6b8",
  null
  
)

export default component.exports